// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/MarketGrowthSection/MarketGrowthSection.css
// module id = 889
// module chunks = 0